import { atom } from "recoil";

export const isExamRoomAddModalOpenState = atom({
  key: "isExamRoomAddModalOpenState",
  default: false,
});

export const isEditCandidateModalOpenState = atom({
  key: "isEditCandidateModalOpenState",
  default: false,
});
export const selectedCandidateState = atom({
  key: "selectedCandidateState",
  default: {},
});

export const isSendMailModalOpenState = atom({
  key: "isSendMailModalOpenState",
  default: false,
});

export const isSendMessageModalOpenState = atom({
  key: "isSendMessageModalOpenState",
  default: false,
});

export const isUrlCheckModalOpenState = atom({
  key: "isUrlCheckModalOpenState",
  default: false,
});
export const isRaterAddModalOpenState = atom({
  key: "isRaterAddModalOpenState",
  default: false,
});
export const isPresetAddModalOpenState = atom({
  key: "isPresetAddModalOpenState",
  default: false,
});
export const isPresetModifyModalOpenState = atom({
  key: "isPresetModifyModalOpenState",
  default: false,
});
export const isSettingAddModalOpenState = atom({
  key: "isSettingAddModalOpenState",
  default: false,
});

export const isQuestionAddModalOpenState = atom({
  key: "isQuestionAddModalOpenState",
  default: false,
});

export const isQuestionModifyModalOpenState = atom({
  key: "isQuestionModifyModalOpenState",
  default: false,
});

export const isTestroomNameState = atom({
  key: "isTestroomNameState",
  default: false,
});

export const isAccountAddCheckModalOpenState = atom({
  key: "isAccountAddCheckModalOpen",
  default: false,
});

// 평가자
export const isShortCutCheckModalOpenState = atom({
  key: "isShortCutCheckModalOpenState",
  default: false,
});
